
import { useContext } from 'react'
import { ThemeContext } from '../context'

export function useDarkTheme() {
  const context = useContext(ThemeContext)
  return context.dark
}